import axios from 'axios'
const ProductModule = {
  namespaced: true,
  state: {
    searchProducts: [],
    searchProductId: '',
    productDetails: [],
    productImages: []
  },
  mutations: {
    FETCH_SEARCH_PRODUCT: (state, payload) => {
      state.searchProducts = payload
    },
    SET_PRODUCT_ID: (state, payload) => {
      state.searchProductId = payload
    },
    SET_PRODUCT_DETAILS: (state, payload) => {
      state.productDetails = payload
    },
    SET_PRODUCT_IMAGES: (state, payload) => {
      state.productImages = payload
    }
  },
  actions: {
    async fetchProductSearch({ commit, dispatch }) {
      try {
        const response = await axios.get('/portal/products/search')
        commit('FETCH_SEARCH_PRODUCT', response.data)
      } catch (error) {
        const notification = {
          type: 'error',
          message: 'There was a problem: ' + error.message
        }
        dispatch('Notification/add', notification, { root: true })
        throw new Error(error)
      }
    },
    async fetchProductDetails({ commit }, payload) {
      try {
        const response = await axios.get(`portal/products/details/${payload}`)
        commit('SET_PRODUCT_DETAILS', response.data)
      } catch (error) {
        // const notification = {
        //   type: 'error',
        //   message: 'Product Details was a problem: ' + error.message
        // }
        // dispatch('Notification/add', notification, { root: true })
        throw new Error(error)
      }
    },
    async fetchProductImages({ commit }, payload) {
      try {
        const response = await axios.get(`portal/products/images/${payload}`)
        commit('SET_PRODUCT_IMAGES', response.data)
      } catch (error) {
        // const notification = {
        //   type: 'error',
        //   message: 'Product Images was a problem: ' + error.message
        // }
        // dispatch('Notification/add', notification, { root: true })
        throw new Error(error)
      }
    }
  },
  getters: {
    getProductDetails: state => {
      return state.productDetails
    },
    getProductImages: state => {
      return state.productImages
    }
    // getByOrderId: state => orderid => {
    //   return state.data.filter(item => item.idx === orderid)
    // },
    // getActive: state => {
    //   return state.data.filter(item => item.status === 'active')
    // }
  }
}

export default ProductModule
